import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function CompetitionServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_1999)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M11.5598 18.6667H5.33317C3.8665 18.6667 2.6665 19.8667 2.6665 21.3334V29.3334H11.5598V18.6667Z"
			      fill={color}/>
			<path
				d="M17.7735 13.3333H14.2135C12.7469 13.3333 11.5469 14.5333 11.5469 15.9999V29.3333H20.4402V15.9999C20.4402 14.5333 19.2535 13.3333 17.7735 13.3333Z"
				fill={color}/>
			<path opacity="0.4"
			      d="M26.6666 22.6667H20.4399V29.3334H29.3333V25.3334C29.3333 23.8667 28.1333 22.6667 26.6666 22.6667Z"
			      fill={color}/>
			<path
				d="M20.0132 6.46674C20.4266 6.0534 20.5866 5.56007 20.4532 5.1334C20.3199 4.70674 19.9066 4.40008 19.3199 4.30674L18.0399 4.09341C17.9866 4.08007 17.8666 4.00005 17.8399 3.94672L17.1332 2.53339C16.5999 1.45339 15.3866 1.45339 14.8532 2.53339L14.1466 3.94672C14.1199 4.00005 13.9999 4.08007 13.9466 4.09341L12.6666 4.30674C12.0799 4.40008 11.6799 4.70674 11.5332 5.1334C11.3999 5.56007 11.5599 6.0534 11.9732 6.46674L12.9599 7.46674C12.9999 7.50674 13.0532 7.66674 13.0399 7.72007L12.7599 8.94672C12.5466 9.85338 12.8932 10.2667 13.1199 10.44C13.3466 10.6 13.8399 10.8134 14.6532 10.3334L15.8532 9.62673C15.9066 9.58673 16.0799 9.58673 16.1332 9.62673L17.3332 10.3334C17.7066 10.5601 18.0132 10.6267 18.2532 10.6267C18.5332 10.6267 18.7332 10.52 18.8532 10.44C19.0799 10.28 19.4266 9.86672 19.2132 8.94672L18.9332 7.72007C18.9199 7.65341 18.9599 7.50674 19.0132 7.46674L20.0132 6.46674Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_1999" x1="11.37" y1="18.6667" x2="2.23265" y2="19.0523"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
